/**
 * Mintegral 一个广告链接对应多本书,书章信息约定塞在 utm_adset 里。
 * 因平台不允许建重复广告,最前面带一段无意义前缀 xxx(不解析,可能自身含下划线),
 * 投放保证 `xxx_{bookId}_` 结构一定存在,故从末尾往前取段。两种有效形式:
 * - xxx_{bookId}_{chapterId}:跳章节阅读页(chapterId 非空)
 * - xxx_{bookId}_:下划线后为空,跳书详情页(chapterId 为 null)
 * 其它情况(不足 3 段、书 id 段为空)视为普通 adset 名,不处理
 */
export function parseMintegralAdsetTarget(utmAdset: string): { bookId: string; chapterId: string | null } | null {
  if (!utmAdset)
    return null
  const parts = utmAdset.split('_')
  if (parts.length < 3)
    return null
  const bookId = parts[parts.length - 2]
  const chapterId = parts[parts.length - 1]
  if (!bookId)
    return null
  return { bookId, chapterId: chapterId || null }
}
